/**
 * Shared read-only "Scope of Work" rendering — used by any screen that
 * displays a Business Order Invoice's `scopeOfWork` array, so the deliverable
 * list looks identical everywhere it's shown.
 */
const ScopeOfWorkView = ({ scopeOfWork, vendors = [], formatAmount = (v) => v }) => {
  const items = Array.isArray(scopeOfWork) ? scopeOfWork : [];
  if (!items.length) {
    return <p className="small text-muted mb-0">No scope of work recorded.</p>;
  }

  return (
    <ul className="small">
      {items.map((block, i) => {
        const blockTax =
          block.taxAmount != null && block.taxAmount !== "" ? block.taxAmount : block.serviceTax;
        const blockLineTotal =
          block.totalAmount != null && block.totalAmount !== "" ? block.totalAmount : block.amount;
        const vendorLabel =
          block.vendorId != null && String(block.vendorId).trim()
            ? vendors.find((v) => String(v._id) === String(block.vendorId))?.vendorName ||
              block.vendorId
            : "";
        const dueDateLabel = (() => {
          if (!block.dueDate) return "";
          const d = new Date(block.dueDate);
          return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB");
        })();
        return (
          <li key={i} className="mb-2">
            <span className="fw-semibold">{block.title || "(No title)"}</span>
            {vendorLabel ? <div className="small text-muted mt-1">Vendor: {vendorLabel}</div> : null}
            {dueDateLabel ? (
              <div className="small text-muted mt-1">Payment due date: {dueDateLabel}</div>
            ) : null}
            {(blockTax != null && blockTax !== "") || (blockLineTotal != null && blockLineTotal !== "") ? (
              <div className="small text-muted mt-1">
                {blockTax != null && blockTax !== "" ? (
                  <span className="me-2">Tax amount: {formatAmount(blockTax)}</span>
                ) : null}
                {blockLineTotal != null && blockLineTotal !== "" ? (
                  <span>Total amount: {formatAmount(blockLineTotal)}</span>
                ) : null}
              </div>
            ) : null}
            {Array.isArray(block.details) && block.details.length ? (
              <ul>
                {block.details.map((line, j) => (
                  <li key={j}>{line}</li>
                ))}
              </ul>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
};

export default ScopeOfWorkView;
